const getErrorStatus = (error: unknown): number | undefined =>
    (error as { response?: { status?: number } } | undefined)?.response?.status;

export default getErrorStatus;
